import React from "react";
import { useDrop } from "react-dnd";
import ConeCont from "./Question7MultiCont"; // update the path as needed

const IceCreamConeDropZone = ({
  index,
  items,
  addTagToIceCone,
  coneItems,
  handleRemoveItem,
  partIccreamCone,
  coneWithoutPart,
}) => {
  const [{ isOver }, drop] = useDrop(() => ({
    accept: "tag",
    drop: (item) => addTagToIceCone(item.id, index),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  }));

  return (
    <div className="scenario2-Questions__imgWrapper__inner__imgWrapper" key={index} ref={drop}>
      <img src={partIccreamCone} alt="partIccreamCone" />
      <div className="scenario2-Questions__imgWrapper__inner__ratedContainer">
        <ConeCont
          handleRemoveItem={handleRemoveItem}
          addTagToIceCone={addTagToIceCone}
          data={coneItems[index + 1]}
          index={index + 1}
        />
      </div>
      <img
        src={coneWithoutPart}
        alt="coneWithoutPart"
        className="scenario2-Questions__imgWrapper__inner__imgWrapper__bigCone"
      />
      <div
        className="scenario2-Questions__imgWrapper__ratesCont__rate"
      >
        {(index === 0 || index === 4) && (
          <div className="scenario2-Questions__imgWrapper__ratesCont__rate__tooltip">
            {" "}
            {`${index === 0
              ? "I'm not good at it"
              : "I'm great at it"
              }`}{" "}
          </div>
        )}
        <span>{items}</span>
      </div>
    </div>
  );
};

export default IceCreamConeDropZone;